import { createAction } from 'redux-api-middleware';
import { push } from 'connected-react-router';
import { omit } from 'lodash';
import { decamelizeKeys } from 'humps';

import Routes from 'utils/routes.js.erb';
import { API_FAILURE, authHeaders } from 'actions';
import { tranformSuccessPayload } from 'actions/transformers';
import { getQueryFromParams } from 'utils/query';
import { selectCardsLibraryMeta } from './selectors';

const READ_ONLY_META_PROPERTIES = [
  'per',
  'totalCount',
  'totalPages',
];

export const CARDS_REQUEST = 'CARDS_REQUEST';
export const CARDS_RECEIVE = 'CARDS_RECEIVE';

export const fetchCards = (params) => createAction({
  endpoint: Routes.api_dashboard_cards_path(decamelizeKeys(params)),
  headers: authHeaders(),
  method: 'GET',
  types: [
    CARDS_REQUEST,
    tranformSuccessPayload(CARDS_RECEIVE),
    API_FAILURE,
  ],
  fetch: fetch,
});

export const updateCardsMeta = (newMeta) => {
  return (dispatch, getState) => {
    const state = getState();
    const meta = selectCardsLibraryMeta(state);

    const params = omit({
      ...meta,
      ...newMeta,
    }, READ_ONLY_META_PROPERTIES);

    dispatch(push({
      search: getQueryFromParams(params)
    }));

    dispatch(fetchCards(params));
  };
};


export const updateCardsFilters = (newFilters) => {
  return updateCardsMeta({
    ...newFilters,
    page: 1,
  });
}
